import banner from './img/research-banner.jpg'
function Contact() {
    return (
        <div className="container-single">
            <p>Feel free to get in touch or stalk me in the following venues</p>
            <p>
                🦆 Twitter: <a href="https://twitter.com/david2vec">@david2vec</a> <br />
                🐙 Github:<a href="https://github.com/dvdmrn">@dvdmrn</a> <br />
                📧 Email: dgm [dot] marino [at] gmail.com // dmarino [at] cim.mcgill.ca <br />
                🤝 LinkedIn: <a href="https://www.linkedin.com/in/dvdgvnnmrn/">david marino</a><br />
            </p>


        </div>
    )
}

export { Contact }